import Corriander from "./../../Assets/images/Meat&Fish/coriander.png";
import Corriander1 from "./../../Assets/images/Meat&Fish/coriander_1.png";
import ChickenMasala from "./../../Assets/images/Meat&Fish/ChickenMasala.png";
import Oil from "./../../Assets/images/Meat&Fish/Oil.png";
import Olive from "./../../Assets/images/Meat&Fish/Olive.png";
import nutCookies from "../../Assets/images/Products/Shop-7.webp";
import TMRice from "../../Assets/images/Products/Shop-8.webp";

const MasalaData =[
    {
        id: 1118,
        title: "Corriander",
        img: Corriander,
        price: 50,
        rating: 5,
      },
      {
        id: 1119,
        title: "Supreme Corriander",
        img: Corriander1,
        price: 80,
        rating: 4,
      },
      {
        id: 1118,
        title: "Corriander",
        img: Corriander,
        price: 50,
        rating: 5,
      },
      {
        id: 1219,
        title: "Tm Rice",
        img: TMRice,
        price: 80,
        rating: 4,
      },
    {
        id: 1218,
        title: "Nut Cookies",
        img: nutCookies,
        price: 50,
        rating: 5,
      },
      {
        id: 1219,
        title: "Tm Rice",
        img: TMRice,
        price: 80,
        rating: 4,
      },
]

export default MasalaData;



